import React from "react";
import "./Termsconditions.css";
import Common_Banner from "../common-components/common_banner/Common_Banner"; // ✅ Import banner

const Termsconditions = () => {
    return (
        <div className="terms-wrapper">

            {/* ✅ Replaced old banner with Common_Banner */}
            <Common_Banner imgSrc="/assets/images/termsandconditions/terms.png" title="Terms & Conditions" />

            <div className="container">
                {/* Content Section */}
                <div className="terms-content">
                    <div className="text_holder">
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                            Lorem Ipsum has been the industry's standard dummy text ever since the
                            1500s, when an unknown printer took a galley of type and scrambled it to
                            make a type specimen book. It has survived not only five centuries,
                            but also the leap into electronic typesetting, remaining essentially unchanged.
                            It was popularised in the 1960s with the release of Letraset sheets containing
                            Lorem Ipsum passages, and more recently with desktop publishing software like Aldus
                            PageMaker including versions of Lorem Ipsum.
                        </p>
                    </div>

                    <div className=" text_holder">
                        <h5>Embedded content from other websites</h5>

                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                            Lorem Ipsum has been the industry's standard dummy text ever since the
                            1500s, when an unknown printer took a galley of type and scrambled it to
                            make a type specimen book. It has survived not only five centuries, but also
                            the leap into electronic typesetting, remaining essentially unchanged.
                        </p>
                    </div>


                    <div className=" text_holder">
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                            Lorem Ipsum has been the industry's standard dummy text ever since the
                            1500s, when an unknown printer took a galley of type and scrambled it to
                            make a type specimen book. It has survived not only five centuries, but also
                            the leap into electronic typesetting, remaining essentially unchanged.
                        </p>
                    </div>

                    <div className=" text_holder">

                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                            Lorem Ipsum has been the industry's standard dummy text ever since the
                            1500s, when an unknown printer took a galley of type and scrambled it to
                            make a type specimen book. It has survived not only five centuries, but also
                            the leap into electronic typesetting, remaining essentially unchanged.
                        </p>
                    </div>
                </div>
            </div>

        </div >
    );
};

export default Termsconditions;
